var React = require('react');

function PlayInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path_67","data-name":"Path 67","d":"M0-9.381l13.108-3.726L9.382,0,4.691-4.69Z","transform":"translate(0 9.268) rotate(45)","fill":"#fff"}));
}

PlayInline.defaultProps = {"width":"18.537","height":"18.538","viewBox":"0 0 18.537 18.538"};

module.exports = PlayInline;

PlayInline.default = PlayInline;
